import React, { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useAuth } from '@strongio/pretrained-dashboard/auth';
import ExternalServiceErrorView from '@strongio/pretrained-dashboard/views/ExternalServiceErrorView';
import { navigationMenuItems, siteName } from '@strongio/pretrained-dashboard/settings';

export default function Index() {
  const router = useRouter();
  const { loadingUser, hasPermission, isAuthenticated } = useAuth();
  const [hasServiceError, setHasServiceError] = useState(false);

  const redirectUser = useCallback(() => {
    if (loadingUser) {
      return; // Wait for the auth to be ready
    }

    if (!isAuthenticated()) {
      router.push('/login');
      return;
    }

    const availableMenus = navigationMenuItems.filter(
    (i) => !i.permission || hasPermission(i.permission));

    if (availableMenus.length === 0) {
      router.push('/settings');
    } else {
      router.push(availableMenus[0].href);
    }
  }, [loadingUser, hasPermission, isAuthenticated, router]);

  useEffect(() => {
    if (router.query.error) {
      setHasServiceError(true);
    } else if (typeof window !== 'undefined') {
      redirectUser();
    }
  }, [redirectUser, router]);

  if (hasServiceError) {
    return /*#__PURE__*/React.createElement(ExternalServiceErrorView, { onClose: redirectUser });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null);
}

Index.getInitialProps = () => ({
  title: siteName,
  noAuth: true });